import { Component, Input } from '@angular/core';
import { TakeawayServices } from "../../../services";
import { Globals } from "../../../../../globals";
import { TakeawaySelectState } from '../../../../components/popups/takeaway-select-state/takeaway-select-state';
import { ModalController, NavController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the TakeawayOrdersStatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-takeaway-orders-state',
  templateUrl: 'takeaway-orders-state.html',
})

export class TakeawayOrdersStatePage {

  @Input() table;
  @Input() state;

  constructor(
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public translate: TranslateService) {
  }

  openTakeawaySelectState(table) {
    //abre modal donde enseñaremos las categorias y que seleccione lo que quiere que se muestre(los seleccionades estaran en array)
    let profileModal = this.modalCtrl.create(TakeawaySelectState,
      {
        title: this.translate.instant("general-selecciona-un-estado"),
        table: table,

      });
    profileModal.onDidDismiss(data => {

    });
    profileModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-orders/takeaway-select-orders/takeaway-orders-state/takeaway-orders-state.ts